import { apiGet } from "./apiRequest";

export const getGraphService = async (deviceId, graphType) =>
    apiGet(`/live-graph?device_mac=${deviceId}&graph_type=${graphType}`);
